import React, { Component } from 'react'
import { Button } from 'antd';
import './index.css'
import { withTranslation } from 'react-i18next';
class NotFound extends Component {
    constructor(props){
        super(props);
    }
    handleClick = ()=>{
        this.props.history.push({ pathname: "/index"})
    }
    render(){
        const { t } = this.props;
        return (
            <div className="error">
                <span className="icon icon-error"></span>
                <p className="strong">{t('not_detail01')}</p>
                <p>{t('not_detail02')}</p>
                <Button type="err-button" size="large" onClick={this.handleClick}>
                    {t('not_detail03')}
                </Button>
            </div>
            )
    }
}
export default withTranslation()(NotFound)
